import React, { createContext, useContext, useState, useEffect } from 'react';
import { voucherThemeService } from '../../services/vouchers/voucherThemeService';

const AgentContext = createContext();

const LOCAL_STORAGE_KEY = 'trrip_voucher_theme';

const DEFAULT_THEME = {
  isCustom: false,
  primaryColor: '#0d9488',
  secondaryColor: '#1d4ed8',
  textColor: '#111827',
  headerBgColor: '#ffffff',
};

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {}
  return DEFAULT_THEME;
};

export const AgentProvider = ({ children }) => {
  const [agent, setAgent] = useState(null);
  const [userData, setUserData] = useState(null);
  const [balance, setBalance] = useState(null);
  const [voucherTheme, setVoucherTheme] = useState(getInitialTheme);

  // Sync with DB whenever agent data arrives or on mount
  useEffect(() => {
    if (agent?.voucher_theme) {
      const themeFromAgent = {
        isCustom: Boolean(agent.voucher_theme.is_custom),
        primaryColor: agent.voucher_theme.primary_color || '#0d9488',
        secondaryColor: agent.voucher_theme.secondary_color || '#1d4ed8',
        textColor: agent.voucher_theme.text_color || '#111827',
        headerBgColor: agent.voucher_theme.header_bg_color || '#ffffff'
      };
      setVoucherTheme(themeFromAgent);
      try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(themeFromAgent));
      } catch (e) {}
    }
  }, [agent]);

  const saveVoucherTheme = async (newTheme) => {
    setVoucherTheme(newTheme);
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newTheme));
    } catch (e) {}

    try {
      await voucherThemeService.updateTheme(newTheme);
    } catch (err) {
      console.warn('Failed to sync voucher theme to server:', err);
    }
  };

  return (
    <AgentContext.Provider
      value={{
        agent,
        setAgent,
        userData,
        setUserData,
        balance,
        setBalance,
        voucherTheme,
        setVoucherTheme,
        saveVoucherTheme
      }}
    >
      {children}
    </AgentContext.Provider>
  );
};

export const useAgent = () => useContext(AgentContext);
